import React from 'react';
import './Signout.css';
import { useNavigate } from 'react-router-dom';

function SignOutButton({ onSignOut }) {
  const navigate = useNavigate();

  const handleSignOut = () => {
    localStorage.removeItem('userId');
    localStorage.removeItem('adminId');
    onSignOut();
    navigate('/');
  };

  return (
    <button className="lbtn" onClick={handleSignOut}>Sign Out</button>
  );
}

export default SignOutButton;
